import React, { useState, useEffect } from 'react';
import MetaTags from '../../components/layout/MetaTags';
import { 
  FiDownload, 
  FiExternalLink, 
  FiPhone,
  FiMapPin
} from 'react-icons/fi';
import { 
  Star,
  ArrowRight
} from '@phosphor-icons/react';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import './Admission.css';
import useAdmission from '../../hooks/useAdmission';
import { ClimbingBoxLoader } from 'react-spinners';

const Admission = () => {
  const { admissionData, loading, error } = useAdmission();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="admission-page">
      <MetaTags
        title="Pendaftaran Santri Baru - Bahrul Ulum Islamic Center"
        description="Informasi lengkap tentang pendaftaran santri baru di Pondok Pesantren Bahrul Ulum Islamic Center. Download brosur dan daftar sekarang!"
      />
      
      <Header />

      <main>
        {/* Hero Section */}
        <section className="adm-hero">
          <div className="adm-hero-bg">
            <div className="adm-hero-circle circle-1"></div>
            <div className="adm-hero-circle circle-2"></div>
            <div className="adm-hero-circle circle-3"></div>
            <div className="adm-hero-pattern"></div>
          </div>
          
          <div className="adm-hero-content">
            <div className="adm-hero-badge">
              <Star weight="fill" className="adm-hero-badge-icon" />
              Pendaftaran Dibuka
            </div>
            
            <h1 className="adm-hero-title">
              <span className="adm-hero-title-line">Penerimaan</span>
              <span className="adm-hero-title-line adm-title-accent">Santri Baru</span>
            </h1>
            
            <p className="adm-hero-desc">
              Bergabunglah dengan ribuan santri yang telah menempuh pendidikan 
              berkualitas di Pondok Pesantren Bahrul Ulum Islamic Center.
            </p>
          </div>
        </section>

        {/* Main Content */}
        <section className={`adm-content-section ${isVisible ? 'adm-visible' : ''}`}>
          <div className="adm-container">
            
            {/* CTA Cards */}
            <div className="adm-cta-grid">
              <a 
                href={admissionData?.brochure_link || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                className="adm-cta-card adm-cta-brochure"
              >
                <div className="adm-cta-icon">
                  <FiDownload />
                </div>
                <div className="adm-cta-content">
                  <h3>Download Brosur</h3>
                  <p>Informasi lengkap tentang program dan fasilitas</p>
                  <span className="adm-cta-link">
                    Download <ArrowRight weight="bold" />
                  </span>
                </div>
              </a>
              
              <a 
                href={admissionData?.admission_link || '#'} 
                target="_blank" 
                rel="noopener noreferrer"
                className="adm-cta-card adm-cta-register"
              >
                <div className="adm-cta-icon">
                  <FiExternalLink />
                </div>
                <div className="adm-cta-content">
                  <h3>Daftar Sekarang</h3>
                  <p>Isi formulir pendaftaran online</p>
                  <span className="adm-cta-link">
                    Daftar <ArrowRight weight="bold" />
                  </span>
                </div>
              </a>
            </div>

            {/* Loading State */}
            {loading && (
              <div className="adm-loading">
                <ClimbingBoxLoader color="#16423c" size={15} />
                <p>Memuat informasi pendaftaran...</p>
              </div>
            )}

            {/* Error State */}
            {error && (
              <div className="adm-error">
                <div className="adm-error-icon">⚠️</div>
                <h3>Gagal Memuat Data</h3>
                <p>Silakan refresh halaman atau coba lagi nanti.</p>
              </div>
            )}

            {/* Content from Server */}
            {!loading && !error && admissionData?.content && (
              <div className="adm-info-wrapper">

                {/* Main Content */}
                <div 
                  className="adm-main-content"
                  dangerouslySetInnerHTML={{ __html: admissionData?.content }} 
                />
              </div>
            )}

            {/* Contact Section */}
            <div className="adm-contact-section">
              <h2 className="adm-section-title">
                <FiPhone className="adm-title-icon" />
                Hubungi Kami
              </h2>
              <p className="adm-contact-desc">
                Punya pertanyaan tentang pendaftaran? Jangan ragu untuk menghubungi kami.
              </p>
              <div className="adm-contact-grid">
                <a href="tel:+6283157938748" className="adm-contact-card">
                  <div className="adm-contact-icon">
                    <FiPhone />
                  </div>
                  <div className="adm-contact-info">
                    <span className="adm-contact-label">Telepon/WhatsApp</span>
                    <span className="adm-contact-value">+62 831-5793-8748</span>
                  </div>
                </a>
                
                <a href="https://maps.app.goo.gl/eqouCgMVTc8SCf366" target="_blank" rel="noopener noreferrer" className="adm-contact-card">
                  <div className="adm-contact-icon">
                    <FiMapPin />
                  </div>
                  <div className="adm-contact-info">
                    <span className="adm-contact-label">Lokasi</span>
                    <span className="adm-contact-value">Sungailiat, Bangka</span>
                  </div>
                </a>
              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Admission;
